// extracted by mini-css-extract-plugin
export default {"formsProgressPopupContent":"MedicalNote_formsProgressPopupContent__F2Q11","loadingSpinner":"MedicalNote_loadingSpinner__MF6ih"};